export { default } from "./Img"
